import { OrganizationUser, USER_ROLES } from '@app/v2/shared/types/user.type'

/**
 * Orders team members with the owner first, then the logged-in user (when not owner), then everyone else.
 * Preserves the relative order of remaining members.
 * @param users Loaded organization users
 * @param currentUserId Logged-in user id in the current workspace
 */
export function orderTeamUsersForDisplay(users: OrganizationUser[], currentUserId: number): OrganizationUser[] {
  if (users.length <= 1 || !currentUserId) return users

  const owner = users.find((user) => user.role === USER_ROLES.OWNER)
  const currentUser = users.find((user) => user.user_id === currentUserId)

  if (!owner || !currentUser || currentUser.role === USER_ROLES.OWNER) {
    return users
  }

  const remaining = users.filter((user) => user.id !== owner.id && user.id !== currentUser.id)
  return [owner, currentUser, ...remaining]
}
